/* Elysian product card: the size chips pick the variant; price and button follow. Dawn's product-form handles the add. */
(function () {
  function bind(card) {
    var priceEl = card.querySelector('[data-ely-price]');
    var idInput = card.querySelector('[data-ely-variant-id]');
    var button = card.querySelector('[data-ely-submit]');
    var label = button ? button.querySelector('span') : null;
    var sizes = card.querySelector('.ely-sizes');
    card.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        /* marks a chosen size, so the savings pill lift (card_next CSS) follows a pick, never the preselected chip on load */
        if (sizes) sizes.setAttribute('data-ely-chosen', '');
        if (idInput) idInput.value = radio.value;
        /* write only what changed (round 4): rewriting identical text repainted the price and the button on every pick.
           data-price is already formatted by Liquid (money_without_trailing_zeros on the home cards, so $56 not $56.00) */
        if (priceEl && radio.dataset.price && priceEl.textContent !== radio.dataset.price) priceEl.textContent = radio.dataset.price;
        var available = radio.dataset.available === 'true';
        if (button) {
          if (button.disabled === available) button.disabled = !available;
          var text = available ? 'Add to Cart' : 'Sold Out';
          if (label && label.textContent !== text) label.textContent = text;
        }
      });
    });
  }
  function init() { document.querySelectorAll('[data-ely-card]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
